import matchtitle from '../../components/matchtitle';
import groupType from './components/group-type.vue';
import groupRules from './components/group-rules.vue';
import groupMutrules from './components/group-mutrules.vue';
export default {
  components: {
    matchtitle,
    groupType,
    groupRules,
    groupMutrules
  },
  data:()=>{
    return {
        tabIndex:1,
    }
  },
  mounted(){
    
  },
  methods:{
    changeTab(index){
      this.tabIndex = index;
    },
    goback(){
      this.$router.go(-1);
    }
  },
  created(){
    
  },
  

};